import {
	Component, Input, Output, OnInit, OnChanges, SimpleChange, SimpleChanges, OnDestroy,
	ViewChild, EventEmitter, ChangeDetectorRef
} from '@angular/core';
import { MessageService } from 'base';
import { MonitorService } from 'monitor';
import { IdentityService } from 'identity';
import { MonitorEditorComponentBase } from '../MonitorEditorComponentBase';
import { SnmpIfSettingsComponent } from '../snmpifsettings/snmpifsettings.component';
import { MonitorScheduleComponent } from '../monitorschedule/monitorschedule.component';
import { MonitorEventsComponent } from '../monitorevents/monitorevents.component';
import { MonitorHistoryComponent } from '../monitorhistory/monitorhistory.component';
import { NavigationService } from 'netview';
import { Schedule } from 'DiscoveryEngine.TS/Utils';
import { SnmpIfDevicesComponent } from '../snmpifdevices/snmpifdevices.component';

@Component({
	selector: 'snmpif-monitor',
	templateUrl: './snmpifmonitor.component.html',
	styleUrls: ['./snmpifmonitor.component.scss']
})
export class SnmpIfMonitorComponent extends MonitorEditorComponentBase {

    @ViewChild(SnmpIfSettingsComponent, { static: true })
	public snmpIfSetsComponent: SnmpIfSettingsComponent;

	@ViewChild(SnmpIfDevicesComponent, { static: true })
	public snmpIfDevicesComponent: SnmpIfDevicesComponent;

    @ViewChild(MonitorScheduleComponent, { static: true })
	public monSchedComponent: MonitorScheduleComponent;

    @ViewChild(MonitorEventsComponent, { static: true })
	public monEventsComponent: MonitorEventsComponent;

    @ViewChild(MonitorHistoryComponent, { static: true })
	public monHistoryComponent: MonitorHistoryComponent;
	
	constructor(monitorService: MonitorService,
		messageService: MessageService,
		identityService: IdentityService,
		navService: NavigationService,
		changeDetector: ChangeDetectorRef) {

		super(monitorService, messageService, identityService, navService, changeDetector);
	}

	public ngOnInit(): void {
		super.ngOnInit();

		this.children = [
			this.snmpIfSetsComponent,
			this.snmpIfDevicesComponent,
			this.monSchedComponent,
			this.monEventsComponent,
			this.monHistoryComponent,
		];
	}

	public ngOnChanges(changes: SimpleChanges): void {
		super.ngOnChanges(changes);
	}

	public ngOnDestroy(): void {
		super.ngOnDestroy();
	}

	public get schedule(): Schedule {
		if (this.monSchedComponent)
			return this.monSchedComponent.value;
		else
			return new Schedule();
	}

}
